import React from 'react';
import { Route, withRouter } from 'react-router';
import UploadDataForm from "./components/uploadDataForm";


const UploadData = () => {
    return (
        <>
            <Route path="/uploaddata" component={withRouter(UploadDataForm)} />
        </>
    )
};

export default UploadData;

